import { useEffect } from "react";
import ShieldCheck from "react-bootstrap-icons/dist/icons/shield-check";

export default function BenReviews() {
  useEffect(() => {
    const existing = document.querySelector(
      'script[src*="doctify-widget-autoresize-plugin.js"]'
    );
    if (existing) return;

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src =
      "https://www.doctify.com/wv2/doctify-widget-autoresize-plugin.js?tenantId=athena-uk&widgetName=average-carousel-rating-widget&containerId=0d6mncpj";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <section id="reviews" className="py-5 benAboutSection">
      <div className="profile-container">
        <div className="benAboutIntro mb-4">
          <div className="benAboutEyebrowWrap">
            <span className="benAboutEyebrowLine"></span>
            <p className="benAboutEyebrow mb-0">WHAT CLIENTS SAY</p>
            <span className="benAboutEyebrowLine"></span>
          </div>

          <h1 className="brand-text-dark mb-0">Reviews</h1>
      
        </div>

<div className="p-2 p-md-4 rounded-4 bg-white bg-opacity-10 border border-white border-opacity-10">
  <iframe
    id="0d6mncpj"
    className="doctify-widget w-100"
    src="https://www.doctify.com/wv2/average-carousel-rating-widget?containerId=0d6mncpj&language=en&profileType=specialist&slugs=dr-benjamin-piper&tenantId=athena-uk&theme=darkNavy&widgetName=average-carousel-rating-widget"
    width="100%"
    frameBorder="0"
    scrolling="no"
    name="average-carousel-rating-widget"
    title="Doctify reviews"
  >
    Browser doesn't support frames
  </iframe>

  {/* <div className="mt-3 brand-text-gray small">
    Use arrows to browse
  </div> */}
</div>
      </div>
    </section>
  );
}